export default __webpack_public_path__ + "static/media/Google.42cd79c0.png";